import React from 'react';

import editIcon from 'images/icons/invite/edit.svg';
import deleteIcon from 'images/icons/invite/delete.svg';

import Actions from './Actions';

import CellArrayItemWithTooltip from '../../../ui/Table/CellArrayItemWithTooltip';

const columns = [
  {
    name: 'Name',
    selector: 'attributes.full_name',
    sortable: true,
    width: '280px',
  },
  {
    name: 'Email',
    selector: 'attributes.email',
    sortable: true,
    width: '260px',
  },
  {
    name: 'Team',
    selector: 'attributes.team',
    sortable: true,
    width: '200px',
  },
  {
    name: 'Program',
    sortable: false,
    width: '200px',
    cell: (row) => (
      <CellArrayItemWithTooltip
        arr={row.attributes.programs.map(
          (item) => item.title + (item.assign_status === '' ? '' : `(${item.assign_status})`),
        )}
      />
    ),
  },
  {
    name: 'Invited On',
    selector: 'attributes.invited_on_formatted',
    sortable: true,
    width: '180px',
    sortFunction: (a, b) => a.attributes.invited_on_timestamp - b.attributes.invited_on_timestamp,
  },
  {
    name: 'Assessment',
    selector: 'attributes.assessment',
    sortable: true,
    width: '200px',
  },
  {
    name: 'Actions',
    sortable: false,
    width: '200px',
    cell: (row) => <Actions row={row} />,
  },
];

export default columns;
